// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"681":"c635d618","768":"fc9a6635"}[chunkId] + ".css";
};